import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { VideoLibrary } from '@mui/icons-material';
import GerenciarSustentacoesOraisDialog from './dialogs/GerenciarSustentacoesOraisDialog';
import { grey, red } from '@mui/material/colors';

class ListaSustentacoesOraisEletronicas extends ReactComponent {
    openSustentacoesOraisEletronicasDialog = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openSustentacoesOraisEletronicasDialog: observable,
            registro: computed,
            handleOpenSustentacoesOraisEletronicasDialog: action,
            handleCloseSustentacoesOraisEletronicasDialog: action,
            totalDocumentosNaoAvaliados: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleOpenSustentacoesOraisEletronicasDialog = () => {
        this.openSustentacoesOraisEletronicasDialog = true;
    };

    handleCloseSustentacoesOraisEletronicasDialog = () => {
        this.openSustentacoesOraisEletronicasDialog = false;
        this.sessaoStore.recarregarProcesso(this.registro);
    };

    get totalDocumentosNaoAvaliados() {
        let _totalDocumentosNaoAvaliados = 0;
        this.registro?.detalhes?.inscricoes?.forEach((inscricao) => {
            inscricao?.documentos
                ?.filter((documento) => documento.excluido === false)
                ?.forEach(({ documentoValidacao }) => {
                    if (documentoValidacao?.validado === true || documentoValidacao?.validado === false) return;
                    _totalDocumentosNaoAvaliados++;
                });
        });
        return _totalDocumentosNaoAvaliados;
    }

    render() {
        return (
            <>
                <Tooltip title="Lista de sustentações orais eletrônicas">
                    <Box component="span">
                        <Button
                            onClick={this.handleOpenSustentacoesOraisEletronicasDialog}
                            sx={{ mr: 1, py: '7px', minWidth: 'auto', position: 'relative' }}
                        >
                            <VideoLibrary sx={{ color: 'black' }} />
                            <Typography
                                sx={{
                                    background: this.totalDocumentosNaoAvaliados > 0 ? red[500] : grey[500],
                                    borderRadius: '50%',
                                    aspectRatio: 1,
                                    minWidth: '18px',
                                    fontSize: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    position: 'absolute',
                                    right: '-10%',
                                    bottom: '0px'
                                }}
                            >
                                {this.totalDocumentosNaoAvaliados}
                            </Typography>
                        </Button>
                    </Box>
                </Tooltip>
                {this.openSustentacoesOraisEletronicasDialog && (
                    <GerenciarSustentacoesOraisDialog
                        registro={this.registro}
                        handleCloseDialog={this.handleCloseSustentacoesOraisEletronicasDialog}
                    />
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ListaSustentacoesOraisEletronicas));
